import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL, heroImage } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative px-4 md:px-6 pt-28 md:pt-36 pb-16 md:pb-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 text-primary-700 px-3 py-1 text-xs font-semibold">
            <i className="ri-sparkling-line"></i>
            {t("home.heroBadge")}
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            {t("home.heroTitle")}
          </h1>
          <p className="mt-5 text-base md:text-lg text-foreground-600 max-w-xl">
            {t("home.heroSubtitle")}
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              {t("home.heroCta1")}
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-base font-semibold text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
            >
              {t("home.heroCta2")}
              <i className="ri-shopping-cart-line"></i>
            </a>
          </div>
          <p className="mt-6 text-xs text-foreground-500">{t("home.heroTrust")}</p>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <div className="relative h-[320px] md:h-[440px] rounded-2xl overflow-hidden border border-background-200">
            <img
              src={heroImage}
              alt="US Fans Spreadsheet fan merchandise collection with sneakers, jersey and hoodie"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 -left-4 bg-background-50 rounded-xl border border-background-200 px-5 py-3">
            <p className="font-heading text-xl font-bold text-primary-600">14+</p>
            <p className="text-xs text-foreground-600 whitespace-nowrap">{t("footer.categories")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}